// Detects whether the app is running as an installed PWA (standalone display mode).
// Used to gate all PWA-only UI so browser users keep the existing experience untouched.
export const isPWA = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  // iOS Safari exposes navigator.standalone instead of the display-mode media query.
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export default isPWA;
